"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Radio = _interopRequireDefault(require("../Radio"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _normalizeOptions = function _normalizeOptions(options) {
  return options.map(function (option) {
    if (typeof option === 'string' || typeof option === 'number') {
      return {
        label: option.toString(),
        value: option
      };
    }

    return option;
  });
};

var _normalizeValue = function _normalizeValue(value) {
  return value !== null ? value.toString() : null;
};

var RadioGroup = function (_React$Component) {
  (0, _inherits2.default)(RadioGroup, _React$Component);

  var _super = _createSuper(RadioGroup);

  function RadioGroup(props) {
    var _this;

    (0, _classCallCheck2.default)(this, RadioGroup);
    _this = _super.call(this, props);

    _this.handleRadioChange = function (value) {
      return function () {
        _this._select(value);
      };
    };

    var _value = null;

    if (props.value !== undefined) {
      _value = props.value;
    } else if (props.defaultValue !== undefined) {
      _value = props.defaultValue;
    }

    _this.state = {
      value: _value
    };
    return _this;
  }

  (0, _createClass2.default)(RadioGroup, [{
    key: "_select",
    value: function _select(value) {
      var _this2 = this;

      var _next = function _next(_prevValue) {
        var hasChanged = _normalizeValue(value) !== _normalizeValue(_prevValue);

        if (_this2.props.onChange && hasChanged) {
          _this2.props.onChange(value);
        }
      };

      var prevValue = this.state.value;

      if (this.props.value === undefined) {
        this.setState(function (prevState) {
          prevValue = prevState.value;
          return {
            value: value
          };
        }, function () {
          _next(prevValue);
        });
      } else {
        _next(prevValue);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var value = this.state.value;
      var _this$props = this.props,
          name = _this$props.name,
          className = _this$props.className,
          vertical = _this$props.vertical,
          options = _this$props.options,
          disabled = _this$props.disabled;

      var children = _normalizeOptions(options).map(function (option) {
        return React.createElement(_Radio.default, {
          key: option.value,
          name: name,
          value: option.value,
          checked: value !== null && option.value === value,
          disabled: option.disabled !== undefined ? option.disabled : disabled,
          onChange: _this3.handleRadioChange(option.value),
          className: "RadioGroup__item"
        }, option.label);
      });

      var _className = (0, _classnames.default)(className, 'RadioGroup', {
        'RadioGroup--vertical': !!vertical
      });

      return React.createElement("div", {
        className: _className
      }, children);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.value !== undefined && prevState.value !== nextProps.value) {
        return {
          value: nextProps.value
        };
      }

      return null;
    }
  }]);
  return RadioGroup;
}(React.Component);

RadioGroup.isFormControl = true;
RadioGroup.displayName = 'Radio.Group';
RadioGroup.defaultProps = {
  name: undefined,
  defaultValue: undefined,
  value: undefined,
  vertical: false,
  disabled: false,
  onChange: undefined,
  className: undefined
};
var _default = RadioGroup;
exports.default = _default;